// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Box,
//   Button,
//   Typography,
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Chip,
//   TextField,
//   Alert,
//   CircularProgress,
//   Divider,
//   Card,
//   CardContent,
//   FormControlLabel,
//   RadioGroup,
//   Radio,
//   Autocomplete,
//   IconButton,
//   Tooltip,
//   useTheme,
//   alpha,
//   styled,
//   ListSubheader
// } from '@mui/material';
// import {
//   FileDownload as ExportIcon,
//   Close as CloseIcon,
//   Email as EmailIcon,
//   DateRange as DateIcon,
//   FilterList as FilterIcon,
//   GetApp as DownloadIcon,
//   Schedule as ScheduleIcon,
//   Person as PersonIcon,
//   Category as CategoryIcon,
//   CheckCircle as CheckIcon,
//   Cancel as CancelIcon
// } from '@mui/icons-material';
// import apiService from 'Network/apiService';
// import { API_ENDPOINTS } from 'Network/apiEndpoints';

// const StyledCard = styled(Card)(({ theme }) => ({
//   marginBottom: theme.spacing(2),
//   backgroundColor: alpha(theme.palette.background.paper, 0.8),
//   border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//   '& .MuiCardContent-root': {
//     padding: theme.spacing(2),
//     '&:last-child': {
//       paddingBottom: theme.spacing(2)
//     }
//   }
// }));

// const SectionHeader = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   gap: theme.spacing(1),
//   marginBottom: theme.spacing(2),
//   padding: theme.spacing(1, 0),
//   borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
//   '& .MuiSvgIcon-root': {
//     color: theme.palette.primary.main,
//     fontSize: '1.2rem'
//   },
//   '& .MuiTypography-root': {
//     fontWeight: 600,
//     color: theme.palette.primary.dark
//   }
// }));

// const EmailChip = styled(Chip)(({ theme }) => ({
//   margin: theme.spacing(0.5),
//   backgroundColor: alpha(theme.palette.info.main, 0.1),
//   color: theme.palette.info.dark,
//   '& .MuiChip-deleteIcon': {
//     color: theme.palette.info.main
//   }
// }));

// const AdvancedExportModal = ({ open, onClose, onRefresh }) => {
//   const theme = useTheme();
  
//   // State for filters
//   const [loading, setLoading] = useState(false);
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState('');
//   const [success, setSuccess] = useState('');

//   // Filter options from API
//   const [statusOptions, setStatusOptions] = useState([]);
//   const [userOptions, setUserOptions] = useState([]);
//   const [categoryOptions, setCategoryOptions] = useState([]);
//   const [companyOptions, setCompanyOptions] = useState([]);
//   const [categoriesLoading, setCategoriesLoading] = useState(false);

//   // Selected filters
//   const [dateRange, setDateRange] = useState({
//     startDate: new Date().toISOString().split('T')[0],
//     endDate: new Date().toISOString().split('T')[0]
//   });
//   const [dateFilter, setDateFilter] = useState('thisMonth');
//   const [selectedStatuses, setSelectedStatuses] = useState([]);
//   const [selectedUsers, setSelectedUsers] = useState([]);
//   const [selectedCategories, setSelectedCategories] = useState([]);
//   const [selectedCompany, setSelectedCompany] = useState('');
//   const [exportFormat, setExportFormat] = useState('excel');
//   const [emails, setEmails] = useState([]);
//   const [emailInput, setEmailInput] = useState('');

//   // Fetch filter options
//   useEffect(() => {
//     if (open) {
//       fetchFilterOptions();
//       handleDateFilterChange('thisMonth');
//     }
//   }, [open]);

//   const fetchFilterOptions = async () => {
//     setLoading(true);
//     setError('');
    
//     try {
//       const [statusChoicesRes, usersRes, companiesRes] = await Promise.all([
//         apiService.get(API_ENDPOINTS.GET_order_status_choices),
//         apiService.get(API_ENDPOINTS.GET_advance_export_users),
//         apiService.get(API_ENDPOINTS.GET_advance_export_company)
//       ]);

//       if (statusChoicesRes?.success) {
//         const statuses = Array.isArray(statusChoicesRes.data) ? statusChoicesRes.data : [];
//         setStatusOptions(statuses.map(s => ({ name: s.name, category: s.category })));
//       }

//       if (usersRes?.success) {
//         setUserOptions(usersRes.data);
//       }

//       if (companiesRes?.success) {
//         setCompanyOptions(companiesRes.data?.Company || []);
//       }
//     } catch (error) {
//       console.error('Error fetching filter options:', error);
//       setError('Failed to load filter options. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fetch categories when company changes
// useEffect(() => {
//   const fetchCategoriesByCompany = async () => {
//     // Clear current selections immediately
//     setCategoryOptions([]);
//     setSelectedCategories([]);

//     if (!selectedCompany) return;

//     try {
//       setCategoriesLoading(true);
//       const res = await apiService.get(
//         `${API_ENDPOINTS.GET_advance_export_product_category_by_company_id}?company=${selectedCompany}`
//       );
//       if (res?.success) {
//         setCategoryOptions(res.data?.ProductCategory || []);
//       }
//     } catch (err) {
//       console.error('Error fetching categories by company:', err);
//       setCategoryOptions([]);
//     } finally {
//       setCategoriesLoading(false);
//     }
//   };

//   fetchCategoriesByCompany();
// }, [selectedCompany]);


//   // Handle date filter changes
//   const handleDateFilterChange = (filterType) => {
//     setDateFilter(filterType);
//     const today = new Date();
    
//     switch (filterType) {
//       case 'thisMonth':
//         const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
//         const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
//         setDateRange({
//           startDate: thisMonthStart.toISOString().split('T')[0],
//           endDate: thisMonthEnd.toISOString().split('T')[0]
//         });
//         break;
//       case 'lastMonth':
//         const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
//         const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
//         setDateRange({
//           startDate: lastMonthStart.toISOString().split('T')[0],
//           endDate: lastMonthEnd.toISOString().split('T')[0]
//         });
//         break;
//       case 'last3Months':
//         const threeMonthsStart = new Date(today.getFullYear(), today.getMonth() - 2, 1);
//         const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
//         setDateRange({
//           startDate: threeMonthsStart.toISOString().split('T')[0],
//           endDate: currentMonthEnd.toISOString().split('T')[0]
//         });
//         break;
//       case 'custom':
//         if (!dateRange.startDate || !dateRange.endDate) {
//           setDateRange({
//             startDate: today.toISOString().split('T')[0],
//             endDate: today.toISOString().split('T')[0]
//           });
//         }
//         break;
//       default:
//         break;
//     }
//   };

//   // Email handling
//   const handleEmailAdd = () => {
//     const email = emailInput.trim();
//     if (email && isValidEmail(email) && !emails.includes(email)) {
//       setEmails([...emails, email]);
//       setEmailInput('');
//     }
//   };

//   const handleEmailRemove = (emailToRemove) => {
//     setEmails(emails.filter(email => email !== emailToRemove));
//   };

//   const isValidEmail = (email) => {
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return emailRegex.test(email);
//   };

//   const handleEmailKeyPress = (event) => {
//     if (event.key === 'Enter' || event.key === ',') {
//       event.preventDefault();
//       handleEmailAdd();
//     }
//   };

//   // Handle export submission
//   const handleExport = async () => {
//     if (emails.length === 0) {
//       setError('Please add at least one email address');
//       return;
//     }

//     setSubmitting(true);
//     setError('');
//     setSuccess('');

//     try {
//       const payload = {
//         start_date: dateRange.startDate,
//         end_date: dateRange.endDate,
//         order_type: 'normal', // Changed from 'bulk' to 'normal'
//         user: selectedUsers.length > 0 ? selectedUsers.join(',') : 'None',
//         company: selectedCompany || 'None',
//         product_category: selectedCategories.length > 0 ? selectedCategories.join(',') : 'None',
//         status: selectedStatuses.length > 0 ? selectedStatuses.join(',') : 'None',
//         emails: emails.join(','),
//         format: exportFormat
//       };

//       console.log('Export payload:', payload);

//       const response = await apiService.post(
//         API_ENDPOINTS.POST_advance_export,
//         payload,
//         'application/json'
//       );

//       if (response?.success) {
//         setSuccess('Export request submitted successfully! You will receive the file via email shortly.');
//         setTimeout(() => {
//           handleClose();
//           onRefresh?.();
//         }, 2000);
//       } else {
//         throw new Error(response?.message || 'Export failed');
//       }
//     } catch (error) {
//       console.error('Error submitting export:', error);
//       setError(error.message || 'Failed to submit export request. Please try again.');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleClose = () => {
//     if (!submitting) {
//       // Reset form
//       setSelectedStatuses([]);
//       setSelectedUsers([]);
//       setSelectedCategories([]);
//       setSelectedCompany('');
//       setEmails([]);
//       setEmailInput('');
//       setError('');
//       setSuccess('');
//       setDateFilter('thisMonth');
//       setExportFormat('excel');
//       onClose();
//     }
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={handleClose}
//       maxWidth="md"
//       fullWidth
//       PaperProps={{
//         sx: {
//           borderRadius: 2,
//           maxHeight: '90vh'
//         }
//       }}
//     >
//       <DialogTitle>
//         <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <ExportIcon color="primary" />
//             <Typography variant="h6" fontWeight={600}>
//               Advanced Export - Products
//             </Typography>
//           </Box>
//           <IconButton onClick={handleClose} disabled={submitting}>
//             <CloseIcon />
//           </IconButton>
//         </Box>
//         <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
//           Configure filters and export settings for product order data
//         </Typography>
//       </DialogTitle>

//       <DialogContent sx={{ pb: 1 }}>
//         {loading ? (
//           <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
//             <CircularProgress />
//             <Typography variant="body2" sx={{ ml: 2 }}>Loading filter options...</Typography>
//           </Box>
//         ) : (
//           <Box sx={{ mt: 1 }}>
//             {error && (
//               <Alert severity="error" sx={{ mb: 2 }}>
//                 {error}
//               </Alert>
//             )}

//             {success && (
//               <Alert severity="success" sx={{ mb: 2 }} icon={<CheckIcon />}>
//                 {success}
//               </Alert>
//             )}

//             <Grid container spacing={3}>
//               {/* Date Range Filter */}
//               <Grid item xs={12}>
//                 <StyledCard>
//                   <CardContent>
//                     <SectionHeader>
//                       <DateIcon />
//                       <Typography variant="h6">Date Range</Typography>
//                     </SectionHeader>
                    
//                     <FormControl component="fieldset" sx={{ mb: 2 }}>
//                       <RadioGroup
//                         row
//                         value={dateFilter}
//                         onChange={(e) => handleDateFilterChange(e.target.value)}
//                         sx={{ gap: 2 }}
//                       >
//                         <FormControlLabel value="custom" control={<Radio />} label="Custom Range" />
//                         <FormControlLabel value="thisMonth" control={<Radio />} label="This Month" />
//                         <FormControlLabel value="lastMonth" control={<Radio />} label="Last Month" />
//                         <FormControlLabel value="last3Months" control={<Radio />} label="Last 3 Months" />
//                       </RadioGroup>
//                     </FormControl>

//                     <Grid container spacing={2}>
//                       <Grid item xs={6}>
//                         <TextField
//                           fullWidth
//                           label="Start Date"
//                           type="date"
//                           value={dateRange.startDate}
//                           onChange={(e) => setDateRange(prev => ({ ...prev, startDate: e.target.value }))}
//                           InputLabelProps={{ shrink: true }}
//                           disabled={dateFilter !== 'custom'}
//                         />
//                       </Grid>
//                       <Grid item xs={6}>
//                         <TextField
//                           fullWidth
//                           label="End Date"
//                           type="date"
//                           value={dateRange.endDate}
//                           onChange={(e) => setDateRange(prev => ({ ...prev, endDate: e.target.value }))}
//                           InputLabelProps={{ shrink: true }}
//                           disabled={dateFilter !== 'custom'}
//                           inputProps={{ min: dateRange.startDate }}
//                         />
//                       </Grid>
//                     </Grid>
//                   </CardContent>
//                 </StyledCard>
//               </Grid>

//               {/* Filters */}
//               <Grid item xs={12} md={6}>
//                 <StyledCard>
//                   <CardContent>
//                     <SectionHeader>
//                       <FilterIcon />
//                       <Typography variant="h6">Order Filters</Typography>
//                     </SectionHeader>

//                     <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontStyle: 'italic' }}>
//                       💡 Leave any filter blank to include all records
//                     </Typography>

//                     {/* Status Filter */}
//                     {/* <FormControl fullWidth sx={{ mb: 2 }}>
//                       <InputLabel  sx={{
//                       backgroundColor: (theme) =>
//                         theme.palette.mode === "dark" ? "#121212" : "#fff",
//                       px: 0.5, // small horizontal padding so text doesn't touch edges
//                     }}>Order Status</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedStatuses}
//                         onChange={(e) => setSelectedStatuses(e.target.value)}
//                         renderValue={(selected) => (
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                             {selected.map((value) => (
//                               <Chip key={value} label={value} size="small" sx={{ borderRadius: 1 }} />
//                             ))}
//                           </Box>
//                         )}
//                       >
//                         {statusOptions.map((status) => (
//                           <MenuItem key={status.name} value={status.name}>
//                             {status.name}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl> */}

//                     <FormControl fullWidth sx={{ mb: 2 }}>
//   <InputLabel
//     sx={{
//       backgroundColor: (theme) =>
//         theme.palette.mode === "dark" ? "#121212" : "#fff",
//       px: 0.5,
//     }}
//   >
//     Order Status
//   </InputLabel>

//   <Select
//     multiple
//     value={selectedStatuses}
//     onChange={(e) => {
//       const value = e.target.value.filter(v => v !== "select-all");
//       setSelectedStatuses(value);
//     }}
//     renderValue={(selected) => (
//       <Box
//         sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
//         onClick={(e) => e.stopPropagation()}
//         onMouseDown={(e) => e.stopPropagation()}
//       >
//         {selected.map((value) => (
//           <Chip
//             key={value}
//             label={value}
//             size="small"
//             sx={{ borderRadius: 1 }}
//             deleteIcon={<CancelIcon />}
//             onDelete={(e) => {
//               e.preventDefault();
//               e.stopPropagation();
//               setSelectedStatuses(
//                 selectedStatuses.filter(status => status !== value)
//               );
//             }}
//           />
//         ))}
//       </Box>
//     )}
//   >
//     {/* Select / Deselect All */}
//     <ListSubheader>
//       <Box sx={{ display: "flex", justifyContent: "space-between", px: 1 }}>
//         <Button
//           size="small"
//           onClick={(e) => {
//             e.stopPropagation();
//             const allStatuses = statusOptions.map(s => s.name);
//             setSelectedStatuses(
//               selectedStatuses.length === allStatuses.length ? [] : allStatuses
//             );
//           }}
//         >
//           {selectedStatuses.length === statusOptions.length
//             ? "Deselect All"
//             : "Select All"}
//         </Button>

//         <Typography variant="caption" color="text.secondary">
//           {selectedStatuses.length} of {statusOptions.length} selected
//         </Typography>
//       </Box>
//     </ListSubheader>

//     <Divider />

//     {statusOptions.map((status) => (
//       <MenuItem key={status.name} value={status.name}>
//         {status.name}
//       </MenuItem>
//     ))}
//   </Select>
// </FormControl>


//                     {/* Company Filter */}
//                     <FormControl fullWidth sx={{ mb: 2 }}>
//                       <InputLabel  sx={{
//                         backgroundColor: (theme) =>
//                           theme.palette.mode === "dark" ? "#121212" : "#fff",
//                         px: 0.5, // small horizontal padding so text doesn't touch edges
//                       }}>Company</InputLabel>
//                       <Select
//                         value={selectedCompany}
//                         onChange={(e) => setSelectedCompany(e.target.value)}
//                       >
//                         {companyOptions.map((company) => (
//                           <MenuItem key={company.id} value={company.id}>
//                             {company.name}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>

//                     {/* Category Filter */}
//                     <FormControl fullWidth>
//                       <InputLabel  sx={{
//                         backgroundColor: (theme) =>
//                           theme.palette.mode === "dark" ? "#121212" : "#fff",
//                         px: 0.5, // small horizontal padding so text doesn't touch edges
//                       }}>Product Categories</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedCategories}
//                         onChange={(e) => {
//                           const value = e.target.value;
//                           // Filter out 'select-all' if it somehow gets included
//                           const filteredValue = value.filter(v => v !== 'select-all');
//                           setSelectedCategories(filteredValue);
//                         }}
//                         disabled={!selectedCompany || categoriesLoading}
//                         renderValue={(selected) => (
//                           <Box 
//                             sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}
//                             onClick={(e) => e.stopPropagation()}
//                             onMouseDown={(e) => e.stopPropagation()}
//                           >
//                             {selected.map((value) => {
//                               const category = categoryOptions.find(cat => cat.id === value);
//                               return (
//                                 <Chip
//                                   key={value}
//                                   label={category?.name || value}
//                                   size="small"
//                                   onDelete={(e) => {
//                                     e.preventDefault();
//                                     e.stopPropagation();
//                                     e.nativeEvent.stopImmediatePropagation();
//                                     setSelectedCategories(selectedCategories.filter(id => id !== value));
//                                   }}
//                                   onClick={(e) => {
//                                     e.preventDefault();
//                                     e.stopPropagation();
//                                   }}
//                                   onMouseDown={(e) => {
//                                     if (e.target.closest('.MuiChip-deleteIcon')) {
//                                       e.preventDefault();
//                                       e.stopPropagation();
//                                     }
//                                   }}
//                                   deleteIcon={<CancelIcon />}
//                                 />
//                               );
//                             })}
//                           </Box>
//                         )}
//                       >
//                         <ListSubheader 
//                           sx={{ 
//                             backgroundColor: 'transparent',
//                             py: 1,
//                             px: 2
//                           }}
//                         >
//                           <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <Button
//                               size="small"
//                               variant="text"
//                               onClick={(e) => {
//                                 e.stopPropagation();
//                                 const allCategoryIds = categoryOptions.map(cat => cat.id);
//                                 setSelectedCategories(
//                                   selectedCategories.length === categoryOptions.length ? [] : allCategoryIds
//                                 );
//                               }}
//                               sx={{ 
//                                 textTransform: 'none',
//                                 fontWeight: 600,
//                                 minWidth: 'auto',
//                                 px: 1.5
//                               }}
//                             >
//                               {selectedCategories.length === categoryOptions.length ? 'Deselect All' : 'Select All'}
//                             </Button>
//                             <Typography variant="caption" color="text.secondary">
//                               {selectedCategories.length} of {categoryOptions.length} selected
//                             </Typography>
//                           </Box>
//                         </ListSubheader>
//                         <Divider />
//                         {categoryOptions.map((category) => (
//                           <MenuItem key={category.id} value={category.id}>
//                             {category.name}
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl>
//                   </CardContent>
//                 </StyledCard>
//               </Grid>

//               {/* Users & Export Settings */}
//               <Grid item xs={12} md={6}>
//                 <StyledCard>
//                   <CardContent>
//                     <SectionHeader>
//                       <PersonIcon />
//                       <Typography variant="h6">Export</Typography>
//                     </SectionHeader>

//                     {/* <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontStyle: 'italic' }}>
//                       💡 Leave user selection blank to include all use
//                     </Typography> */}

//                     {/* Users Filter */}  
//                     {/* <FormControl fullWidth sx={{ mb: 2 }}>
//                       <InputLabel>Users</InputLabel>
//                       <Select
//                         multiple
//                         value={selectedUsers}
//                         onChange={(e) => setSelectedUsers(e.target.value)}
//                         renderValue={(selected) => (
//                           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//                             {selected.map((value) => {
//                               const user = userOptions.find(user => user.id === value);
//                               return (
//                                 <Chip key={value} label={user?.name || value} size="small" />
//                               );
//                             })}
//                           </Box>
//                         )}
//                       >
//                         {userOptions.map((user) => (
//                           <MenuItem key={user.id} value={user.id}>
//                             <Box>
//                               <Typography variant="body2">{user.name}</Typography>
//                               <Typography variant="caption" color="text.secondary">
//                                 {user.mobile} • {user.user_type}
//                               </Typography>
//                             </Box>
//                           </MenuItem>
//                         ))}
//                       </Select>
//                     </FormControl> */}

//                     {/* Export Format */}
//                     <FormControl fullWidth>
//                       <InputLabel
//                        sx={{
//                       backgroundColor: (theme) =>
//                         theme.palette.mode === "dark" ? "#121212" : "#fff",
//                       px: 0.5, // small horizontal padding so text doesn't touch edges
//                     }}>Export Format</InputLabel>
//                       <Select
//                         value={exportFormat}
//                         onChange={(e) => setExportFormat(e.target.value)}
//                       >
//                         <MenuItem value="excel">Excel (.xlsx)</MenuItem>
//                         <MenuItem value="csv">CSV (.csv)</MenuItem>
//                       </Select>
//                     </FormControl>
//                   </CardContent>
//                 </StyledCard>
//               </Grid>

//               {/* Email Configuration */}
//               <Grid item xs={12}>
//                 <StyledCard>
//                   <CardContent>
//                     <SectionHeader>
//                       <EmailIcon />
//                       <Typography variant="h6">Email Configuration</Typography>
//                     </SectionHeader>

//                     <TextField
//                       fullWidth
//                       label="Add Email Address"
//                       value={emailInput}
//                       onChange={(e) => setEmailInput(e.target.value)}
//                       onKeyPress={handleEmailKeyPress}
//                       placeholder="Enter email and press Enter or comma"
//                       helperText="Press Enter or comma to add multiple emails"
//                       InputProps={{
//                         endAdornment: (
//                           <Button
//                             size="small"
//                             onClick={handleEmailAdd}
//                             disabled={!emailInput.trim() || !isValidEmail(emailInput.trim())}
//                           >
//                             Add
//                           </Button>
//                         )
//                       }}
//                     />

//                     {emails.length > 0 && (
//                       <Box sx={{ mt: 2 }}>
//                         <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                           Email Recipients ({emails.length}):
//                         </Typography>
//                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                           {emails.map((email, index) => (
//                             <EmailChip
//                               key={index}
//                               label={email}
//                               onDelete={() => handleEmailRemove(email)}
//                               deleteIcon={<CancelIcon />}
//                             />
//                           ))}
//                         </Box>
//                       </Box>
//                     )}
//                   </CardContent>
//                 </StyledCard>
//               </Grid>
//             </Grid>
//           </Box>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ px: 3, pb: 2 }}>
//         <Button 
//           onClick={handleClose} 
//           disabled={submitting}
//           sx={{ textTransform: 'none' }}
//         >
//           Cancel
//         </Button>
//         <Button
//           onClick={handleExport}
//           variant="contained"
//           disabled={submitting || loading || emails.length === 0}
//           startIcon={submitting ? <CircularProgress size={16} /> : <DownloadIcon />}
//           sx={{ textTransform: 'none', minWidth: 120 }}
//         >
//           {submitting ? 'Processing...' : 'Export Data'}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default AdvancedExportModal; 



import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  TextField,
  Alert,
  CircularProgress,
  Divider,
  Card,
  CardContent,
  FormControlLabel,
  RadioGroup,
  Radio,
  IconButton,
  useTheme,
  alpha,
  styled,
  ListSubheader,
  Snackbar
} from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import {
  FileDownload as ExportIcon,
  Close as CloseIcon,
  Email as EmailIcon,
  DateRange as DateIcon,
  FilterList as FilterIcon,
  GetApp as DownloadIcon,
  Person as PersonIcon,
  CheckCircle as CheckIcon,
  Cancel as CancelIcon
} from '@mui/icons-material';
import apiService from 'Network/apiService';
import { API_ENDPOINTS } from 'Network/apiEndpoints';
 
const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  backgroundColor: alpha(theme.palette.background.paper, 0.8),
  border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  '& .MuiCardContent-root': {
    padding: theme.spacing(2),
    '&:last-child': {
      paddingBottom: theme.spacing(2)
    }
  }
}));
 
const SectionHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  marginBottom: theme.spacing(2),
  padding: theme.spacing(1, 0),
  borderBottom: `2px solid ${alpha(theme.palette.primary.main, 0.1)}`,
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
    fontSize: '1.2rem'
  },
  '& .MuiTypography-root': {
    fontWeight: 600,
    color: theme.palette.primary.dark
  }
}));
 
const EmailChip = styled(Chip)(({ theme }) => ({
  margin: theme.spacing(0.5),
  backgroundColor: alpha(theme.palette.info.main, 0.1),
  color: theme.palette.info.dark,
  '& .MuiChip-deleteIcon': {
    color: theme.palette.info.main
  }
}));
 
const AdvancedExportModal = ({ open, onClose, onRefresh }) => {
  const theme = useTheme();
 
  // Toast state
  const [toast, setToast] = useState({
    open: false,
    message: '',
    severity: 'success'
  });
 
  // State for filters
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
 
  // Filter options from API
  const [statusOptions, setStatusOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [categoriesLoading, setCategoriesLoading] = useState(false);
 
  // Selected filters
  const [dateRange, setDateRange] = useState({
    startDate: new Date().toISOString().split('T')[0],
    endDate: new Date().toISOString().split('T')[0]
  });
  const [dateFilter, setDateFilter] = useState('thisMonth');
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState('');
  const [exportFormat, setExportFormat] = useState('excel');
  const [emails, setEmails] = useState([]);
  const [emailInput, setEmailInput] = useState('');
 
  // Toast handlers
  const handleToastClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setToast({ ...toast, open: false });
  };
 
  const showToast = (message, severity = 'success') => {
    setToast({
      open: true,
      message,
      severity
    });
  };
 
  // Fetch filter options
  useEffect(() => {
    if (open) {
      fetchFilterOptions();
      handleDateFilterChange('thisMonth');
    }
  }, [open]);
 
  const fetchFilterOptions = async () => {
    setLoading(true);
    setError('');
   
    try {
      const [statusChoicesRes, usersRes, companiesRes] = await Promise.all([
        apiService.get(API_ENDPOINTS.GET_order_status_choices),
        apiService.get(API_ENDPOINTS.GET_advance_export_users),
        apiService.get(API_ENDPOINTS.GET_advance_export_company)
      ]);
 
      if (statusChoicesRes?.success) {
        const statuses = Array.isArray(statusChoicesRes.data) ? statusChoicesRes.data : [];
        setStatusOptions(statuses.map(s => ({ name: s.name, category: s.category })));
      }
 
      if (usersRes?.success) {
        setUserOptions(usersRes.data);
      }
 
      if (companiesRes?.success) {
        setCompanyOptions(companiesRes.data?.Company || []);
      }
    } catch (error) {
      console.error('Error fetching filter options:', error);
      setError('Failed to load filter options. Please try again.');
      showToast('Failed to load filter options', 'error');
    } finally {
      setLoading(false);
    }
  };
 
  // Fetch categories when company changes
  useEffect(() => {
    const fetchCategoriesByCompany = async () => {
      setCategoryOptions([]);
      setSelectedCategories([]);
 
      if (!selectedCompany) return;
 
      try {
        setCategoriesLoading(true);
        const res = await apiService.get(
          `${API_ENDPOINTS.GET_advance_export_product_category_by_company_id}?company=${selectedCompany}`
        );
        if (res?.success) {
          setCategoryOptions(res.data?.ProductCategory || []);
        }
      } catch (err) {
        console.error('Error fetching categories by company:', err);
        setCategoryOptions([]);
        showToast('Failed to load categories', 'error');
      } finally {
        setCategoriesLoading(false);
      }
    };
 
    fetchCategoriesByCompany();
  }, [selectedCompany]);
 
  // Handle date filter changes
  const handleDateFilterChange = (filterType) => {
    setDateFilter(filterType);
    const today = new Date();
   
    switch (filterType) {
      case 'thisMonth':
        const thisMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        setDateRange({
          startDate: thisMonthStart.toISOString().split('T')[0],
          endDate: thisMonthEnd.toISOString().split('T')[0]
        });
        break;
      case 'lastMonth':
        const lastMonthStart = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastMonthEnd = new Date(today.getFullYear(), today.getMonth(), 0);
        setDateRange({
          startDate: lastMonthStart.toISOString().split('T')[0],
          endDate: lastMonthEnd.toISOString().split('T')[0]
        });
        break;
      case 'last3Months':
        const threeMonthsStart = new Date(today.getFullYear(), today.getMonth() - 2, 1);
        const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        setDateRange({
          startDate: threeMonthsStart.toISOString().split('T')[0],
          endDate: currentMonthEnd.toISOString().split('T')[0]
        });
        break;
      case 'custom':
        if (!dateRange.startDate || !dateRange.endDate) {
          setDateRange({
            startDate: today.toISOString().split('T')[0],
            endDate: today.toISOString().split('T')[0]
          });
        }
        break;
      default:
        break;
    }
  };
 
  // Email handling
  const handleEmailAdd = () => {
    const email = emailInput.trim();
    if (email && isValidEmail(email) && !emails.includes(email)) {
      setEmails([...emails, email]);
      setEmailInput('');
      // showToast('Email added successfully', 'success');
    } else if (emails.includes(email)) {
      showToast('Email already exists', 'warning');
    } else if (!isValidEmail(email)) {
      showToast('Please enter a valid email', 'error');
    }
  };
 
  const handleEmailRemove = (emailToRemove) => {
    setEmails(emails.filter(email => email !== emailToRemove));
    // showToast('Email removed', 'info');
  };
 
  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
 
  const handleEmailKeyPress = (event) => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      handleEmailAdd();
    }
  };
 
  // Handle export submission
  const handleExport = async () => {
    if (emails.length === 0) {
      setError('Please add at least one email address');
      showToast('Please add at least one email address', 'error');
      return;
    }
 
    setSubmitting(true);
    setError('');
    setSuccess('');
 
    try {
      const payload = {
        start_date: dateRange.startDate,
        end_date: dateRange.endDate,
        order_type: 'normal',
        user: selectedUsers.length > 0 ? selectedUsers.join(',') : 'None',
        company: selectedCompany || 'None',
        product_category: selectedCategories.length > 0 ? selectedCategories.join(',') : 'None',
        status: selectedStatuses.length > 0 ? selectedStatuses.join(',') : 'None',
        emails: emails.join(','),
        format: exportFormat
      };
 
      console.log('Export payload:', payload);
 
      const response = await apiService.post(
        API_ENDPOINTS.POST_advance_export,
        payload,
        'application/json'
      );
 
      if (response?.success) {
        setSuccess('Export request submitted successfully!');
        showToast(' Downloded successfully!', 'success');
       
        setTimeout(() => {
          handleClose();
          onRefresh?.();
        }, 2000);
      } else {
        throw new Error(response?.message || 'Export failed');
      }
    } catch (error) {
      console.error('Error submitting export:', error);
      const errorMessage = error.message || 'Failed to submit export request. Please try again.';
      setError(errorMessage);
      showToast(errorMessage, 'error');
    } finally {
      setSubmitting(false);
    }
  };
 
  const handleClose = () => {
    if (!submitting) {
      // Reset form
      setSelectedStatuses([]);
      setSelectedUsers([]);
      setSelectedCategories([]);
      setSelectedCompany('');
      setEmails([]);
      setEmailInput('');
      setError('');
      setSuccess('');
      setDateFilter('thisMonth');
      setExportFormat('excel');
      onClose();
    }
  };
 
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: '90vh'
          }
        }}
      >
        <DialogTitle>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <ExportIcon color="primary" />
              <Typography variant="h6" fontWeight={600}>
                Advanced Export - Products
              </Typography>
            </Box>
            <IconButton onClick={handleClose} disabled={submitting}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            Configure filters and export settings for product order data
          </Typography>
        </DialogTitle>
 
        <DialogContent sx={{ pb: 1 }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
              <CircularProgress />
              <Typography variant="body2" sx={{ ml: 2 }}>Loading filter options...</Typography>
            </Box>
          ) : (
            <Box sx={{ mt: 1 }}>
              {error && !toast.open && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
 
              {success && !toast.open && (
                <Alert severity="success" sx={{ mb: 2 }} icon={<CheckIcon />}>
                  {success}
                </Alert>
              )}
 
              <Grid container spacing={3}>
                {/* Date Range Filter */}
                <Grid item xs={12}>
                  <StyledCard>
                    <CardContent>
                      <SectionHeader>
                        <DateIcon />
                        <Typography variant="h6">Date Range</Typography>
                      </SectionHeader>
                     
                      <FormControl component="fieldset" sx={{ mb: 2 }}>
                        <RadioGroup
                          row
                          value={dateFilter}
                          onChange={(e) => handleDateFilterChange(e.target.value)}
                          sx={{ gap: 2 }}
                        >
                          <FormControlLabel value="custom" control={<Radio />} label="Custom Range" />
                          <FormControlLabel value="thisMonth" control={<Radio />} label="This Month" />
                          <FormControlLabel value="lastMonth" control={<Radio />} label="Last Month" />
                          <FormControlLabel value="last3Months" control={<Radio />} label="Last 3 Months" />
                        </RadioGroup>
                      </FormControl>
 
                      <Grid container spacing={2}>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="Start Date"
                            type="date"
                            value={dateRange.startDate}
                            onChange={(e) => setDateRange(prev => ({ ...prev, startDate: e.target.value }))}
                            InputLabelProps={{ shrink: true }}
                            disabled={dateFilter !== 'custom'}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            label="End Date"
                            type="date"
                            value={dateRange.endDate}
                            onChange={(e) => setDateRange(prev => ({ ...prev, endDate: e.target.value }))}
                            InputLabelProps={{ shrink: true }}
                            disabled={dateFilter !== 'custom'}
                            inputProps={{ min: dateRange.startDate }}
                          />
                        </Grid>
                      </Grid>
                    </CardContent>
                  </StyledCard>
                </Grid>
 
                {/* Filters */}
                <Grid item xs={12} md={6}>
                  <StyledCard>
                    <CardContent>
                      <SectionHeader>
                        <FilterIcon />
                        <Typography variant="h6">Order Filters</Typography>
                      </SectionHeader>
 
                      <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontStyle: 'italic' }}>
                        💡 Leave any filter blank to include all records
                      </Typography>
 
                      {/* Status Filter */}
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            backgroundColor: (theme) =>
                              theme.palette.mode === "dark" ? "#121212" : "#fff",
                            px: 0.5,
                          }}
                        >
                          Order Status
                        </InputLabel>
 
                        <Select
                          multiple
                          value={selectedStatuses}
                          onChange={(e) => {
                            const value = e.target.value.filter(v => v !== "select-all");
                            setSelectedStatuses(value);
                          }}
                          renderValue={(selected) => (
                            <Box
                              sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                            >
                              {selected.map((value) => (
                                <Chip
                                  key={value}
                                  label={value}
                                  size="small"
                                  sx={{ borderRadius: 1 }}
                                  deleteIcon={<CancelIcon />}
                                  onDelete={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setSelectedStatuses(
                                      selectedStatuses.filter(status => status !== value)
                                    );
                                  }}
                                />
                              ))}
                            </Box>
                          )}
                        >
                          {/* Select / Deselect All */}
                          <ListSubheader>
                            <Box sx={{ display: "flex", justifyContent: "space-between", px: 1 }}>
                              <Button
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const allStatuses = statusOptions.map(s => s.name);
                                  setSelectedStatuses(
                                    selectedStatuses.length === allStatuses.length ? [] : allStatuses
                                  );
                                }}
                              >
                                {selectedStatuses.length === statusOptions.length
                                  ? "Deselect All"
                                  : "Select All"}
                              </Button>
 
                              <Typography variant="caption" color="text.secondary">
                                {selectedStatuses.length} of {statusOptions.length} selected
                              </Typography>
                            </Box>
                          </ListSubheader>
 
                          <Divider />
 
                          {statusOptions.map((status) => (
                            <MenuItem key={status.name} value={status.name}>
                              {status.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
 
                      {/* Company Filter */}
                      <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel
                          sx={{
                            backgroundColor: (theme) =>
                              theme.palette.mode === "dark" ? "#121212" : "#fff",
                            px: 0.5,
                          }}
                        >
                          Company
                        </InputLabel>
                        <Select
                          value={selectedCompany}
                          onChange={(e) => setSelectedCompany(e.target.value)}
                        >
                          {companyOptions.map((company) => (
                            <MenuItem key={company.id} value={company.id}>
                              {company.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
 
                      {/* Category Filter */}
                      <FormControl fullWidth>
                        <InputLabel
                          sx={{
                            backgroundColor: (theme) =>
                              theme.palette.mode === "dark" ? "#121212" : "#fff",
                            px: 0.5,
                          }}
                        >
                          Product Categories
                        </InputLabel>
                        <Select
                          multiple
                          value={selectedCategories}
                          onChange={(e) => {
                            const value = e.target.value;
                            const filteredValue = value.filter(v => v !== 'select-all');
                            setSelectedCategories(filteredValue);
                          }}
                          disabled={!selectedCompany || categoriesLoading}
                          renderValue={(selected) => (
                            <Box
                              sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}
                              onClick={(e) => e.stopPropagation()}
                              onMouseDown={(e) => e.stopPropagation()}
                            >
                              {selected.map((value) => {
                                const category = categoryOptions.find(cat => cat.id === value);
                                return (
                                  <Chip
                                    key={value}
                                    label={category?.name || value}
                                    size="small"
                                    onDelete={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      e.nativeEvent.stopImmediatePropagation();
                                      setSelectedCategories(selectedCategories.filter(id => id !== value));
                                    }}
                                    deleteIcon={<CancelIcon />}
                                  />
                                );
                              })}
                            </Box>
                          )}
                        >
                          <ListSubheader
                            sx={{
                              backgroundColor: 'transparent',
                              py: 1,
                              px: 2
                            }}
                          >
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <Button
                                size="small"
                                variant="text"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  const allCategoryIds = categoryOptions.map(cat => cat.id);
                                  setSelectedCategories(
                                    selectedCategories.length === categoryOptions.length ? [] : allCategoryIds
                                  );
                                }}
                                sx={{
                                  textTransform: 'none',
                                  fontWeight: 600,
                                  minWidth: 'auto',
                                  px: 1.5
                                }}
                              >
                                {selectedCategories.length === categoryOptions.length ? 'Deselect All' : 'Select All'}
                              </Button>
                              <Typography variant="caption" color="text.secondary">
                                {selectedCategories.length} of {categoryOptions.length} selected
                              </Typography>
                            </Box>
                          </ListSubheader>
                          <Divider />
                          {categoryOptions.map((category) => (
                            <MenuItem key={category.id} value={category.id}>
                              {category.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </CardContent>
                  </StyledCard>
                </Grid>
 
                {/* Users & Export Settings */}
                <Grid item xs={12} md={6}>
                  <StyledCard>
                    <CardContent>
                      <SectionHeader>
                        <PersonIcon />
                        <Typography variant="h6">Export</Typography>
                      </SectionHeader>
 
                      {/* Export Format */}
                      <FormControl fullWidth>
                        <InputLabel
                          sx={{
                            backgroundColor: (theme) =>
                              theme.palette.mode === "dark" ? "#121212" : "#fff",
                            px: 0.5,
                          }}
                        >
                          Export Format
                        </InputLabel>
                        <Select
                          value={exportFormat}
                          onChange={(e) => setExportFormat(e.target.value)}
                        >
                          <MenuItem value="excel">Excel (.xlsx)</MenuItem>
                          <MenuItem value="csv">CSV (.csv)</MenuItem>
                        </Select>
                      </FormControl>
                    </CardContent>
                  </StyledCard>
                </Grid>
 
                {/* Email Configuration */}
                <Grid item xs={12}>
                  <StyledCard>
                    <CardContent>
                      <SectionHeader>
                        <EmailIcon />
                        <Typography variant="h6">Email Configuration</Typography>
                      </SectionHeader>
 
                      <TextField
                        fullWidth
                        label="Add Email Address"
                        value={emailInput}
                        onChange={(e) => setEmailInput(e.target.value)}
                        onKeyPress={handleEmailKeyPress}
                        placeholder="Enter email and press Enter or comma"
                        helperText="Press Enter or comma to add multiple emails"
                        InputProps={{
                          endAdornment: (
                            <Button
                              size="small"
                              onClick={handleEmailAdd}
                              disabled={!emailInput.trim() || !isValidEmail(emailInput.trim())}
                            >
                              Add
                            </Button>
                          )
                        }}
                      />
 
                      {emails.length > 0 && (
                        <Box sx={{ mt: 2 }}>
                          <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            Email Recipients ({emails.length}):
                          </Typography>
                          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                            {emails.map((email, index) => (
                              <EmailChip
                                key={index}
                                label={email}
                                onDelete={() => handleEmailRemove(email)}
                                deleteIcon={<CancelIcon />}
                              />
                            ))}
                          </Box>
                        </Box>
                      )}
                    </CardContent>
                  </StyledCard>
                </Grid>
              </Grid>
            </Box>
          )}
        </DialogContent>
 
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleClose}
            disabled={submitting}
            sx={{ textTransform: 'none' }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleExport}
            variant="contained"
            disabled={submitting || loading || emails.length === 0}
            startIcon={submitting ? <CircularProgress size={16} /> : <DownloadIcon />}
            sx={{ textTransform: 'none', minWidth: 120 }}
          >
            {submitting ? 'Processing...' : 'Export Data'}
          </Button>
        </DialogActions>
      </Dialog>
 
      {/* Toast Snackbar */}
      <Snackbar
        open={toast.open}
        autoHideDuration={3000}
        onClose={handleToastClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MuiAlert
          onClose={handleToastClose}
          severity={toast.severity}
          sx={{ width: '100%' }}
          elevation={6}
          variant="filled"
        >
          {toast.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
};
 
export default AdvancedExportModal;